(function () {
  'use strict';

  var SESSION_BASE = ''; // relative — served by the same Cloudflare Worker on crocobricks.com
  var SHOPIFY_BASE = 'https://www.crocobricks.com';
  var POLL_INTERVAL = 2000;
  var QR_SESSION_TIMEOUT = 300000; // 5 min

  var selectedFile = null;
  var isSearching = false;
  var pollTimer = null;
  var sessionId = null;

  var fileInput, cameraInput, previewWrap, previewImg;
  var searchBtn, resultsContainer, loadingEl, errorEl;

  // ── helpers ──────────────────────────────────────────────────────────────

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function isDesktop() {
    return !('ontouchstart' in window) && window.innerWidth >= 768;
  }

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  // Teksten per taal staan niet in dit script. De pagina levert ze via
  // <script type="application/json" id="cb-camera-search-i18n"> met de
  // sleutels uit cb.camera_search.* in de locales. Zonder dat blok blijft
  // de Engelse standaardtekst staan.
  var i18n = null;
  function txt(key) {
    if (!i18n) {
      i18n = {
        shoot_label: 'Tap to take photo',
        phone_header: '📷 Take a photo of your LEGO part',
        phone_sub: 'The result will appear on your computer automatically',
        retry: 'Take another photo',
        sent: 'Result sent to your computer!',
        qr_title: '📱 Scan with your phone',
        qr_sub_html: 'Open your camera app and scan the QR code.<br>Take a photo of the LEGO part — the result appears here automatically.',
        qr_status: 'Waiting for phone…',
        expired: '⏱ Session expired. Close and try again.',
        received: '✅ Photo received!'
      };
      var el = document.getElementById('cb-camera-search-i18n');
      if (el) {
        try {
          var given = JSON.parse(el.textContent);
          for (var k in given) {
            if (Object.prototype.hasOwnProperty.call(given, k) && given[k]) i18n[k] = given[k];
          }
        } catch (e) { /* ongeldig blok: standaardtekst houden */ }
      }
    }
    return i18n[key];
  }

  // Taalroot van de winkel ('/' of de taalmap, bv. /nl/); Shopify zet die op elke pagina.
  function localeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  // ── init ─────────────────────────────────────────────────────────────────

  function init() {
    fileInput        = document.getElementById('cb-file-input');
    cameraInput      = document.getElementById('cb-camera-input');
    previewWrap      = document.getElementById('cb-preview-wrap');
    previewImg       = document.getElementById('cb-preview-img');
    searchBtn        = document.getElementById('cb-search-btn');
    resultsContainer = document.getElementById('cb-results');
    loadingEl        = document.getElementById('cb-loading');
    errorEl          = document.getElementById('cb-error');

    if (!fileInput) return;

    // Phone arrived via QR code
    var qrSession = getUrlParam('session');
    var isQrSource = getUrlParam('source') === 'qr';

    if (qrSession && isQrSource) {
      sessionId = qrSession;
      showPhoneMode();
      wireUpButtons(true);
      return;
    }

    wireUpButtons(false);
    searchBtn.addEventListener('click', runSearch);
  }

  function wireUpButtons(phoneMode) {
    var cameraBtn  = document.getElementById('cb-camera-btn');
    var uploadBtn  = document.getElementById('cb-upload-btn');
    var connectBtn = document.getElementById('cb-connect-btn');

    if (uploadBtn) {
      uploadBtn.addEventListener('click', function () { fileInput.click(); });
    }

    if (cameraBtn) {
      cameraBtn.addEventListener('click', function () {
        if (!phoneMode && isDesktop()) {
          showQrModal();
        } else {
          cameraInput.click();
        }
      });
    }

    if (connectBtn) {
      connectBtn.addEventListener('click', function () { showQrModal(); });
      // Hide "Connect with phone" on touch devices — they already have a camera
      if ('ontouchstart' in window) connectBtn.style.display = 'none';
    }

    if (phoneMode) {
      // Phone: auto-send immediately after photo selection — no preview, no button
      if (previewWrap) previewWrap.style.display = 'none';
      fileInput.addEventListener('change', function (e) {
        var file = e.target.files[0];
        if (file) { selectedFile = file; runPhoneSearch(); }
        e.target.value = '';
      });
      cameraInput.addEventListener('change', function (e) {
        var file = e.target.files[0];
        if (file) { selectedFile = file; runPhoneSearch(); }
        e.target.value = '';
      });
    } else {
      fileInput.addEventListener('change', onFileSelected);
      cameraInput.addEventListener('change', onFileSelected);
    }
  }

  // ── phone mode ───────────────────────────────────────────────────────────

  function showPhoneMode() {
    // Replace entire action area with a single full-width tap-to-shoot button
    var actions = document.querySelector('.cb-cs-actions');
    if (actions) {
      actions.innerHTML =
        '<button type="button" class="cb-action-btn cb-action-btn--shoot" id="cb-shoot-btn">' +
          '<span class="cb-action-btn__icon">📷</span>' +
          '<span class="cb-action-btn__label">' + txt('shoot_label') + '</span>' +
        '</button>';
      document.getElementById('cb-shoot-btn').addEventListener('click', function () {
        cameraInput.click();
      });
    }

    var header = document.querySelector('.cb-cs-header h1');
    if (header) header.textContent = txt('phone_header');
    var sub = document.querySelector('.cb-cs-header p');
    if (sub) sub.textContent = txt('phone_sub');
  }

  function runPhoneSearch() {
    if (!selectedFile || isSearching) return;
    isSearching = true;
    searchBtn.disabled = true;
    searchBtn.textContent = 'Sending…';
    hideError();
    showLoading();

    var formData = new FormData();
    formData.append('query_image', selectedFile);

    fetch('https://api.brickognize.com/predict/', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('API error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var items = (data.items || []).filter(function (i) { return (i.score || 0) >= 0.15; }).slice(0, 3);
        if (!items.length) {
          showError('No LEGO part recognised. Try a clearer photo on a plain background.');
          return Promise.resolve([]);
        }
        return lookupShopifyProducts(items);
      })
      .then(function (results) {
        if (!results || !results.length) return;
        return postResultsToPortal(results);
      })
      .catch(function (err) {
        console.error('[CrocoBricks camera-search]', err);
        showError('Something went wrong. Please try again.');
      })
      .then(function () {
        isSearching = false;
        searchBtn.disabled = false;
        searchBtn.textContent = '📷 Search';
        hideLoading();
      });
  }

  function postResultsToPortal(results) {
    return fetch(SESSION_BASE + '/api/camera-session/' + sessionId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ results: results })
    })
      .then(function () {
        var retryLabel = txt('retry');
        resultsContainer.innerHTML =
          '<div class="cb-cs-sent">' +
            '<p>✅ ' + txt('sent') + '</p>' +
            '<button type="button" class="cb-action-btn cb-action-btn--shoot cb-cs-sent__retry" id="cb-retry-btn">' +
              '<span class="cb-action-btn__icon">🔄</span>' +
              '<span class="cb-action-btn__label">' + esc(retryLabel) + '</span>' +
            '</button>' +
          '</div>';
        document.getElementById('cb-retry-btn').addEventListener('click', function () {
          resultsContainer.innerHTML = '';
          hideError();
          cameraInput.click();
        });
      })
      .catch(function () {
        showError('Could not send result to desktop. Please try again.');
      });
  }

  // ── desktop QR option ────────────────────────────────────────────────────

  function showQrModal() {
    // Generate a fresh UUID if no session exists yet, or if the previous poll already stopped
    if (!sessionId || !pollTimer) sessionId = generateUUID();
    var phonePage = localeRoot() + 'pages/find-part-by-image';
    var qrUrl = SHOPIFY_BASE + phonePage + '?session=' + sessionId + '&source=qr';
    var qrImgUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' + encodeURIComponent(qrUrl);

    var t = {
      title:  txt('qr_title'),
      sub:    txt('qr_sub_html'),
      status: txt('qr_status')
    };

    var existing = document.getElementById('cb-qr-modal');
    if (existing) existing.remove();

    var modal = document.createElement('div');
    modal.id = 'cb-qr-modal';
    modal.className = 'cb-qr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="cb-qr-modal__backdrop"></div>' +
      '<div class="cb-qr-modal__box">' +
        '<button class="cb-qr-modal__close" aria-label="Close">&times;</button>' +
        '<p class="cb-qr-modal__title">' + t.title + '</p>' +
        '<img class="cb-qr-modal__img" src="' + esc(qrImgUrl) + '" alt="QR code" width="220" height="220">' +
        '<p class="cb-qr-modal__sub">' + t.sub + '</p>' +
        '<div class="cb-qr-modal__status" id="cb-qr-modal-status">' + t.status + '</div>' +
      '</div>';

    document.body.appendChild(modal);

    // Close on backdrop or × click
    modal.querySelector('.cb-qr-modal__backdrop').addEventListener('click', closeQrModal);
    modal.querySelector('.cb-qr-modal__close').addEventListener('click', closeQrModal);

    // Start polling if not already running
    if (!pollTimer) startPolling();
  }

  function closeQrModal() {
    var modal = document.getElementById('cb-qr-modal');
    if (modal) modal.remove();
  }


  function startPolling() {
    if (pollTimer) clearInterval(pollTimer);
    var deadline = Date.now() + QR_SESSION_TIMEOUT;

    pollTimer = setInterval(function () {
      if (Date.now() > deadline) {
        clearInterval(pollTimer);
        pollTimer = null;
        var statusEl = document.getElementById('cb-qr-modal-status');
        if (statusEl) statusEl.textContent = txt('expired');
        return;
      }
      pollSession();
    }, POLL_INTERVAL);
  }

  function pollSession() {
    fetch(SESSION_BASE + '/api/camera-session/' + sessionId, {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (res.status === 204) return null; // still waiting
        if (!res.ok) throw new Error('Poll error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        clearInterval(pollTimer);
        pollTimer = null;
        var receivedMsg = txt('received');
        var statusEl = document.getElementById('cb-qr-status');
        if (statusEl) statusEl.textContent = receivedMsg;
        var modalStatusEl = document.getElementById('cb-qr-modal-status');
        if (modalStatusEl) modalStatusEl.textContent = receivedMsg;
        setTimeout(closeQrModal, 800);
        renderResults(data.results);
        // Scroll to results
        if (resultsContainer) {
          resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (err) {
        console.warn('[CrocoBricks camera-search] poll error:', err);
      });
  }

  // ── normal (desktop direct upload) ───────────────────────────────────────

  function onFileSelected(e) {
    var file = e.target.files[0];
    if (file) setFile(file);
    e.target.value = '';
  }

  function setFile(file) {
    selectedFile = file;
    var reader = new FileReader();
    reader.onload = function (e) {
      previewImg.src = e.target.result;
      previewWrap.style.display = 'block';
      searchBtn.disabled = false;
      resultsContainer.innerHTML = '';
      hideError();
    };
    reader.readAsDataURL(file);
  }

  function runSearch() {
    if (!selectedFile || isSearching) return;
    isSearching = true;
    searchBtn.disabled = true;
    searchBtn.textContent = 'Searching…';
    resultsContainer.innerHTML = '';
    hideError();
    showLoading();

    var formData = new FormData();
    formData.append('query_image', selectedFile);

    fetch('https://api.brickognize.com/predict/', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('API error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var items = (data.items || []).filter(function (i) { return (i.score || 0) >= 0.15; }).slice(0, 3);
        if (!items.length) {
          showError('No LEGO part recognised. Try a clearer photo with better lighting and a plain background.');
          return Promise.resolve();
        }
        return lookupShopifyProducts(items).then(renderResults);
      })
      .catch(function (err) {
        console.error('[CrocoBricks camera-search]', err);
        showError('Something went wrong. Please try again.');
      })
      .then(function () {
        isSearching = false;
        searchBtn.disabled = false;
        searchBtn.textContent = '📷 Search';
        hideLoading();
      });
  }

  // ── shared lookup + render ────────────────────────────────────────────────

  function suggestProducts(query, limit) {
    return fetch(
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' + (limit || 1)
    )
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return (d.resources && d.resources.results && d.resources.results.products) || [];
      })
      .catch(function () { return []; });
  }

  function lookupShopifyProducts(items) {
    var promises = items.map(function (item) {
      var partId = item.id || item.external_id || '';
      var name   = item.name || '';

      // 1st try: exact tag match (Item-2417)
      return suggestProducts('Item-' + partId, 1)
        .then(function (products) {
          var product = products[0] || null;
          // 2nd try: name search if tag found nothing
          if (!product && name) {
            return suggestProducts(name, 1).then(function (p2) {
              return p2[0] || null;
            });
          }
          return product;
        })
        .then(function (product) {
          return { brickognize: item, shopify: product };
        });
    });

    return Promise.all(promises);
  }

  function renderResults(results) {
    if (!results || !results.length) {
      showError('No matching parts found in our store for this photo.');
      return;
    }

    // All results identified but none in stock — give a more helpful message
    var anyInStock = results.some(function (r) { return !!r.shopify; });
    if (!anyInStock) {
      var names = results.map(function (r) { return r.brickognize.name || ('Part ' + (r.brickognize.id || '?')); });
      showError('We identified this as ' + names[0] + ' (Part #' + (results[0].brickognize.id || '?') + '), but it\'s not currently in our store. Try searching manually.');
      return;
    }

    var html = '<div class="cb-cs-results-header"><h2>Top matches for your photo</h2></div>';
    html += '<div class="cb-cs-grid">';

    results.forEach(function (r) {
      var item    = r.brickognize;
      var product = r.shopify;
      var partId  = item.id || item.external_id || '?';
      var name    = item.name || ('Part ' + partId);
      var confidence = item.score ? Math.round(item.score * 100) : null;
      var brickImg = item.img_url || '';

      if (product) {
        var imgSrc = brickImg || (product.image && product.image.src) || '';
        var priceRaw = product.price || product.price_min;
        var price = priceRaw && parseFloat(priceRaw) > 0 ? '€' + parseFloat(priceRaw).toFixed(2) : null;

        html += '<div class="cb-cs-card">';
        html += '  <img class="cb-cs-card__img" src="' + esc(imgSrc) + '" alt="' + esc(name) + '" loading="lazy" onerror="this.style.display=\'none\'">';
        html += '  <div class="cb-cs-card__body">';
        if (confidence !== null) html += '    <span class="cb-cs-card__confidence">' + confidence + '% match</span>';
        html += '    <h3 class="cb-cs-card__title">' + esc(product.title || name) + '</h3>';
        html += '    <p class="cb-cs-card__part-id">Part #' + esc(String(partId)) + '</p>';
        if (price) html += '    <p class="cb-cs-card__price">From ' + price + '</p>';
        html += '  </div>';
        html += '  <div class="cb-cs-card__footer">';
        html += '    <a href="' + esc(product.url) + '" class="cb-cs-card__btn">View product</a>';
        html += '  </div>';
        html += '</div>';
      } else {
        html += '<div class="cb-cs-card cb-cs-card--unavailable">';
        if (brickImg) html += '  <img class="cb-cs-card__img" src="' + esc(brickImg) + '" alt="' + esc(name) + '" loading="lazy" onerror="this.style.display=\'none\'">';
        html += '  <div class="cb-cs-card__body">';
        if (confidence !== null) html += '    <span class="cb-cs-card__confidence">' + confidence + '% match</span>';
        html += '    <h3 class="cb-cs-card__title">' + esc(name) + '</h3>';
        html += '    <p class="cb-cs-card__part-id">Part #' + esc(String(partId)) + '</p>';
        html += '    <p class="cb-cs-card__unavailable">Not currently in stock</p>';
        html += '  </div>';
        html += '  <div class="cb-cs-card__footer">';
        html += '    <a href="/collections/all-parts?q=' + encodeURIComponent(name) + '" class="cb-cs-card__btn cb-cs-card__btn--outline">Browse similar</a>';
        html += '  </div>';
        html += '</div>';
      }
    });

    html += '</div>';
    resultsContainer.innerHTML = html;

    // Animate cards in and scroll to first result
    var cards = resultsContainer.querySelectorAll('.cb-cs-card');
    cards.forEach(function (card, i) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(24px)';
      card.style.transition = 'opacity 0.35s ease ' + (i * 0.1) + 's, transform 0.35s ease ' + (i * 0.1) + 's';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        });
      });
    });

    if (cards.length) {
      setTimeout(function () {
        cards[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 80);
    }
  }

  // ── utilities ─────────────────────────────────────────────────────────────

  function showLoading() { if (loadingEl) loadingEl.style.display = 'block'; }
  function hideLoading() { if (loadingEl) loadingEl.style.display = 'none'; }
  function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; } }
  function hideError()    { if (errorEl) errorEl.style.display = 'none'; }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
